import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { HeaderComponent, NavbarComponent, FooterComponent } from '../../presentation';
import { DataGetService } from '../../domain';

export default function MainLayout() {
    const [paramsData, setParamsData] = React.useState([]);
    const _DataGetService = new DataGetService();

    const parametersGet = async () => {
        try {
            const paramsList = ['BPI_SUSTAINABILITY_LOGO'];

            const { parameters = [] } = await _DataGetService.execute();
            const filteredParams = parameters?.filter?.((item) => paramsList.includes(item.paramName)) || [];
            setParamsData(filteredParams);
        } catch (error) {
            console.error('Error fetching parameters:', error);
        }
    };

    useEffect(() => {
        parametersGet();
    }, []);

    return (
        <div>
            <NavbarComponent />
            <HeaderComponent />
            <Outlet />
            <FooterComponent paramsData={paramsData} />
        </div>
    );
}
